import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Period' })({
    root: {
        display: 'flex',
        width: 'fit-content',
        padding: 4,
        alignItems: 'center',
        borderRadius: 100,
        background: 'rgba(255, 255, 255, 0.05)'
    },
    button: {
        display: 'flex',
        flex: '1 0 114px',
        boxSizing: 'border-box',
        padding: '12px 24px',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 100,
        color: '#fff',
        textAlign: 'center',
        fontSize: 14,
        fontWeight: 400,
        lineHeight: '16px',
        transition: 'all 0.2s',
        cursor: 'pointer'
    },
    _active: {
        background: '#fff',
        color: '#232323',
        cursor: 'default'
    }
});
